import { HttpInterceptorFn } from '@angular/common/http';

export const recoveryInterceptor: HttpInterceptorFn = (request, next) => {
  let recoveryToken = sessionStorage.getItem('recovery_token');

  if (recoveryToken) {
    request = request.clone({
      headers: request.headers.append('RecoveryToken', recoveryToken),
    });
  }

  return next(request);
};
